<template>
  <icon-svg-base :class="$style.icon" :view-width="24" :view-height="24">
    <path
      :class="$style.icon__path"
      d="M20,11a1,1,0,0,0-1,1v6a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5h6a1,1,0,0,0,0-2H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12A1,1,0,0,0,20,11Z"
    />
    <path
      :class="$style.icon__path"
      d="M16,5h1.58l-6.29,6.28a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L19,6.42V8a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1L16,3h0a1,1,0,0,0,0,2Z"
    />
  </icon-svg-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconExternalLink',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  $size: 1em;

  width: $size;
  height: $size;

  &__path {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
